export function createQuery(host, type, durationStart = '-60m', durationEnd = '0m', durationInterval = '5m') {
  if (type === 'snmp') {
    return `
from(bucket: "telegraf")
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => r["_measurement"] == "hr_storage")
  |> filter(fn: (r) => r["agent_host"] == "${host}")
  |> filter(fn: (r) => r["_field"] == "storage_usage_percentage")
  |> filter(fn: (r) => r["storage_descr"] == "/" or r["storage_descr"] == "/data")
  |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
  |> yield(name: "mean")
`
  }

  return `
from(bucket: "telegraf")
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => r["_measurement"] == "ezelink_df_value")
  |> filter(fn: (r) => r["type"] == "percent_bytes")
  |> filter(fn: (r) => r["host"] == "${host}")
  |> filter(fn: (r) => r["type_instance"] == "used")
  |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
  |> map(fn: (r) => ({
      r with
      storage_descr: r.instance
  }))
  |> drop(columns: ["instance"])
  |> yield(name: "mean")
`
}
